import React from 'react'
import { Table } from 'antd'
import Drawer from 'components/Drawer'
import AntdAvatar from 'components/Avatar'

// Read-only drawer that lists the colleges a role has ALREADY been published
// to (in edit / republish mode). Data comes from getRoleLinks(jobId) and is
// passed in via `data`. No selection, no actions — purely informational.
const tierStyle = tier => {
  switch (tier) {
    case 1:
      return { backgroundColor: '#FFE5ED', color: '#964D65', border: '1px solid #964D65' }
    case 2:
      return { backgroundColor: '#E7E0FF', color: '#7D64DA', border: '1px solid #7D64DA' }
    case 3:
      return { backgroundColor: '#E0F7FF', color: '#55A1BA', border: '1px solid #55A1BA' }
    case 4:
      return { backgroundColor: '#E0FFE5', color: '#58B981', border: '1px solid #58B981' }
    default:
      return { backgroundColor: '#e0e0e0', color: '#555', border: '1px solid #e0e0e0' }
  }
}

const PublishedCollegesDrawer = ({ open, onClose, data = [] }) => {
  const columns = [
    {
      title: 'College Name',
      dataIndex: 'campusName',
      key: 'campusName',
      render: (text, record) => {
        const name = record?.campusName || record?.collegeName || '-'
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <AntdAvatar
              src={record?.logo}
              size={36}
              IconName={name && name.length > 0 ? name.trim()[0].toUpperCase() : '-'}
            />
            <span
              style={{
                fontSize: 14,
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                fontWeight: 500,
                marginLeft: 4,
              }}
            >
              {name}
            </span>
          </span>
        )
      },
    },
    {
      title: 'Location',
      key: 'location',
      render: (text, record) => {
        const city = record?.city || '-'
        const state = record?.state || '-'
        return `${city}, ${state}`
      },
    },
    {
      title: 'Tier',
      key: 'tier',
      align: 'center',
      render: (text, record) => {
        const tier = record?.corporateDetails?.tier || record?.tier
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                ...tierStyle(tier),
                borderRadius: '15px',
                padding: '4px 12px',
                minWidth: '80px',
                fontWeight: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Tier {tier || '-'}
            </div>
          </div>
        )
      },
    },
  ]

  const content = (
    <div style={{ padding: 24 }}>
      <div
        style={{
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: 14,
          color: '#555',
          marginBottom: 16,
        }}
      >
        This role is already published to <b>{data.length}</b>{' '}
        {data.length === 1 ? 'institute' : 'institutes'}. These colleges stay
        selected and cannot be published to again.
      </div>
      <Table
        rowKey="instituteCampusId"
        columns={columns}
        dataSource={data || []}
        pagination={false}
      />
    </div>
  )

  return (
    <Drawer
      zIndex={'1002'}
      width="60%"
      padding="0px 30px"
      title={`Already Published Colleges (${data.length})`}
      placement="right"
      onClose={onClose}
      closable={true}
      visible={open}
      content={content}
      footer={null}
    />
  )
}

export default PublishedCollegesDrawer
